/**
 * Tier 0 of the perfusion skeleton, taken away.
 *
 * The silhouette itself is markup in `index.html`, painted before this bundle exists — the only
 * thing that can be on screen while the entry chunk is being parsed. It sits over the app on a
 * high `z-index` so that it also covers the gap between the app mounting and the dashboard's route
 * chunk arriving, which means nothing removes it implicitly: Vue mounting into `#app` leaves it
 * exactly where it is.
 *
 * Called from wherever the load ends up, because which of those fires depends on how it went:
 *
 *  - `SurgeonDashboard.vue` mounting — the intended path. Tier 1 has rendered by the time this
 *    runs, so the two swap on one frame and nothing blank shows between them.
 *  - a navigation that resolved somewhere else — an expired session sent to the login form, most
 *    often, where the URL said dashboard and the page is not one.
 *  - a chunk that failed to load, and the bootstrap failure screen, neither of which will ever
 *    mount a dashboard.
 *
 * Idempotent, since several of those can happen in one load.
 */
export const removeBootSkeleton = (): void => {
  document.getElementById('boot-skeleton')?.remove();
  // The attribute is the inline stylesheet's switch. Left set, a later navigation back to the
  // dashboard within the same document would re-show a silhouette over a page already on screen.
  document.documentElement.removeAttribute('data-boot-skeleton');
};
